import { Text } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { Comment } from './hooks'
import { CommentContainer, CommentDate, CommentHeader, CommentText } from './styled'

export type CommentItemProps = {
  comment: Comment
  setIsEdit?: (arg: boolean) => void
  setComment?: (text: string) => void
  setCommentId?: (id: string) => void
  isEdit?: boolean
}

export const CommentsItem = ({ comment }: CommentItemProps) => {
  const formatDate = useFormatDate()
  return (
    <CommentContainer>
      <CommentHeader>
        <Text as="span" typography="accentMedium">
          {comment.author}
        </Text>
        <CommentDate>{formatDate(comment.created, { withTime: true })}</CommentDate>
      </CommentHeader>
      <CommentText>{comment.comment}</CommentText>
    </CommentContainer>
  )
}
